<template>
  <div class="form-wrap">
    <div class="form-content">
      <!-- 标题 -->
      <h1 class="common-header">
        <i class="el-icon-arrow-left icon-button" @click="$emit('close', 1)"></i>
        {{ $t('449') }}
      </h1>
      <!-- 内容 -->
      <el-tabs v-model="activeName">
        <!-- 考勤规则设置 -->
        <el-tab-pane :label="$t('1934')" name="1">
          <el-form :model="form" ref="form" label-width="280px">
            <!-- 出勤天数计算规则 -->
            <el-form-item :label="$t('1935')">
              <el-radio-group v-model="form.at_type">
                <!-- 按照班次设置时长折算 -->
                <el-radio :label="1" class="margin-top">{{ $t('1936') }} </el-radio>
                <!-- 说明 -->
                <p class="attendance-detail margin-bottom">{{ $t('1937') }}</p>
                <!-- 按照打卡次数计算 -->
                <el-radio :label="2">{{ $t('1938') }} </el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 员工缺卡1次时 -->
            <el-form-item :label="$t('1939')" label-width="380px" v-if="form.at_type === 2">
              <el-radio-group v-model="form.miss_click_once">
                <!-- 仍记为全勤 -->
                <el-radio :label="1" class="margin-bottom margin-top block">{{ $t('1940') }}</el-radio>
                <!-- 记录为0.5天出勤 -->
                <el-radio :label="2" class="margin-bottom block">{{ $t('1941') }}</el-radio>
                <!-- 记录为0天出勤 -->
                <el-radio :label="3" class="margin-bottom block">{{ $t('1942') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 保存 -->
            <div class="pagination">
              <!-- 取消 -->
              <el-button @click="$emit('close', 1)" :disabled="loading">{{ $t('66') }}</el-button>
              <!-- 保存 -->
              <el-button type="primary" @click="setAttendanceSetting" :loading="loading">
                {{ $t('67') }}
              </el-button>
            </div>
          </el-form>
        </el-tab-pane>
        <!-- 考勤周期设置 -->
        <el-tab-pane :label="$t('1943')" name="2">
          <p>
            {{ AttendanceText }} <el-button type="text" @click="handleEdit">{{ $t('1945') }}</el-button>
          </p>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 考勤设置 -->
    <!-- 1 新增（新增时如果已经存在则提示刷新） 2 更新 -->
    <AttendanceCycleSettings :type="2" ref="cycleSetting" @updateText="handlerText" />
  </div>
</template>

<script>
// 设置月度汇总考勤的考勤规则
import { setAttendanceSetting, getAttendanceSetting } from 'api/Attendance/monthly-statistics'
// 考勤周期设置
import AttendanceCycleSettings from './attendance-cycle-settings'

export default {
  components: {
    AttendanceCycleSettings
  },
  data() {
    return {
      activeName: '1',
      loading: false,
      form: {
        at_type: 1, // 1 按照班次设置时长折算 2 按照打卡次数计算
        miss_click_once: 1 // 员工缺卡1次时 1 仍记为全勤 2 记录为0.5天出勤 3 记录为0天出勤
      },
      AttendanceText: ''
    }
  },
  created() {
    getAttendanceSetting().then(res => {
      this.form = res.data
    })
  },
  methods: {
    // 编辑考勤周期
    handleEdit() {
      this.$refs.cycleSetting.visible = true
    },
    // 考勤展示文案
    handlerText(attenText) {
      this.AttendanceText = attenText
    },
    // 设置考勤
    setAttendanceSetting() {
      this.$util.messageBox(this.$t('1970'), 'warning', () => {
        this.loading = true
        setAttendanceSetting(this.form)
          .then(() => {
            this.$emit('close', 1)
          })
          .finally(() => (this.loading = false))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form-wrap {
  margin: 0 auto;
  position: relative;
  .form-content {
    // height: calc(100% - 110px);
    .block {
      display: block;
    }
    .common-header {
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      width: calc(100% + 50px);
      transform: translateX(-25px) translateY(-2px);
      padding: 0 25px 15px 25px;
      font-size: 16px;
      user-select: none;
      margin-bottom: 22px;
      &::before {
        display: none;
      }
    }
    .attendance-detail {
      opacity: 0.5;
      padding: 5px 0 0 24px;
      font-size: 12px;
    }
  }
}
</style>
